export function getRoles(roles: any, user?: any) {
  if (!user) {
    return []
  }

  const memberOf = user.memberOf.toArray()
  const rolesArray = roles.toArray()

  const rolesOfUser = []
  const roleMemberOf = []
  for (const i in memberOf) {
    if (memberOf[i].type === 'Role') {
      roleMemberOf.push(memberOf[i].authenticatorId)
    }
  }

  for (const i in rolesArray) {
    if (roleMemberOf.indexOf(rolesArray[i].id) > -1) {
      rolesOfUser.push(rolesArray[i])
    }
  }

  return rolesOfUser
}

export function getTeams(teams: any, user?: any) {
  if (!user) {
    return []
  }

  const memberOf = user.memberOf.toArray()
  const teamsArray = teams.toArray()

  const teamsOfUser = []
  const teamMemberOf = []
  for (const i in memberOf) {
    if (memberOf[i].type === 'Team') {
      teamMemberOf.push(memberOf[i].authenticatorId)
    }
  }

  for (const i in teamsArray) {
    if (teamMemberOf.indexOf(teamsArray[i].id) > -1) {
      teamsOfUser.push(teamsArray[i])
    }
  }

  return teamsOfUser
}
